export default "__VITE_ASSET__DpNlT_Mf__"